import { render, staticRenderFns } from "./blank-base.vue?vue&type=template&id=61821aa9&"
import script from "./blank-base.vue?vue&type=script&lang=js&"
export * from "./blank-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports